import { StatsSnowplow2ActionEnum } from 'common/module/stats/snowplow2/action.enum';

export const StatsSnowplow2ActionFlushBuffer = {
  action: StatsSnowplow2ActionEnum.flushBuffer,
};
